// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export const MAX_PLAYERS = 8;

// Reported with game-artwork media requests made from the tour editor.
export const TOUR_EDIT_MEDIA_PAGE_PATH = '/tour/[tourId]/edit';
export const AUTO_SAVE_DEBOUNCE_MS = 800;
export const ACK_TIMEOUT_MS = 12000;

export const SIDEBAR_WIDTH_DEFAULT = 300;
export const SIDEBAR_WIDTH_WIDE = 340;
export const SIDEBAR_BREAKPOINT = 1200;
export const MOBILE_BREAKPOINT = 820;

// Uploading the bytes is the slow leg and depends on the user's connection, so
// this is far more generous than ACK_TIMEOUT_MS — it exists only so a stalled
// upload eventually reports failure instead of spinning forever.
export const IMAGE_UPLOAD_TIMEOUT_MS = 60000;
